import React, { useState } from "react";
import Navbar from "./Navbar";

const Liberty = () => {
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const handleProceed = () => {
    if (acceptedTerms) {
      alert("Proceeding to the next step...");
    }
  };

  return (
    <>
      <Navbar />
    <div className="app-wrapper">
      <div className="mobile-container">
        {/* Header Section */}
        <div className="header">
          <h2 className="page-title">Claim Details</h2>
        </div>
        {/* Claim Info Section */}
        <div className="section row-split border-bottom">
          <div className="field">
            <span className="label">Claim Number:</span>
            <span className="value">CL-8829301</span>
          </div>
          <div className="field">
            <span className="label">Intimation Date:</span>
            <span className="value">24-Oct-2023</span>
          </div>
        </div>
        {/* Insured Section */}
        <div className="section border-bottom">
          <div className="field">
            <span className="label section-label">Insured</span>
            <span className="value main-text">Alexander J. Sterling</span>
          </div>
        </div>

        {/* Vehicle Section */}
        <div className="section border-bottom">
          <span className="label section-label">Vehicle</span>

          <div className="grid-row">
            <div className="field">
              <span className="label">Manufacturer:</span>
              <span className="value center-text">Toyota</span>
            </div>
            <div className="field">
              <span className="label">Model:</span>
              <span className="value center-text">Toyota</span>
            </div>
            <div className="field">
              <span className="label">Variant:</span>
              <span className="value center-text">XLE Premium AWD</span>
            </div>
          </div>
          {/* Gap requested between Manufacturer row and Year of Registration */}
          <div className="spacer"></div>
          <div className="field">
            <span className="label">Year of Registration</span>
            <span className="value">2021</span>
          </div>
        </div>
        {/* Terms and Conditions */}
        <div className="terms-section">
          <input
            type="checkbox"
            id="termsCheckbox"
            className="checkbox"
            checked={acceptedTerms}
            onChange={(e) => setAcceptedTerms(e.target.checked)}
          />
          <label htmlFor="termsCheckbox" className="terms-label">
            I have read and agree the Terms of Service and Privacy Policy.
          </label>
        </div>
        {/* Action Button */}
        <div className="footer">
          <div className="footerDiv">
            <button
              className={`proceed-btn ${acceptedTerms ? "active" : "disabled"}`}
              onClick={handleProceed}
              disabled={!acceptedTerms}
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Liberty;
